export default {
    es: {
        menu: {
            notifications: 'Notificaciones',
            settings: 'Configuración',
            profile: 'Perfil',
            administration: 'Administración',
            company: 'Empresa',
            security: 'Seguridad',
            createUser: 'Crear Usuario',
            testUser: 'Probar Usuario',
            searchUser: 'Buscar usuario...',
            myProfile: 'Mi Perfil',
            logout: 'Cerrar sesión',
            support: 'Soporte',
            modules: 'Módulos',
            modifyMenu: 'Modificar Menú',
            embeddedView: 'Vista Embebida',
            editMenu: 'Modificar menú',
            configMenu: 'Menú de configuración',
            mainMenu: 'Menú principal',
        },
    },
    en: {
        menu: {
            notifications: 'Notifications',
            settings: 'Settings',
            profile: 'Profile',
            administration: 'Administration',
            company: 'Company',
            security: 'Security',
            createUser: 'Create User',
            testUser: 'Test User',
            searchUser: 'Search user...',
            myProfile: 'My Profile',
            logout: 'Log out',
            support: 'Support',
            modules: 'Modules',
            modifyMenu: 'Edit Menu',
            embeddedView: 'Embedded View',
            editMenu: 'Edit menu',
            configMenu: 'Settings menu',
            mainMenu: 'Main menu',
        },
    },
}
